/**
 * @since 2.0.0
 */
/** @internal */
export const getBugErrorMessage = message => `BUG: ${message} - please report an issue at https://github.com/Effect-TS/effect/issues`;
//# sourceMappingURL=errors.js.map